import { withSvgIcon } from './withSvgIcon';

export const ReferralIcon = withSvgIcon(
  <>
    <path
      d="M16 14H6C4.89543 14 4 14.8954 4 16V19.5"
      stroke="currentColor"
      strokeWidth="2"
    />
    <circle cx="11" cy="7" r="3" stroke="currentColor" strokeWidth="2" />
    <path d="M15 19H21" stroke="currentColor" strokeWidth="2" />
    <path d="M18 22V16" stroke="currentColor" strokeWidth="2" />
  </>,
  { viewBox: '0 0 24 24' },
);
